/**
 * [ File :: B_Inventory.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/child/attr/B_Inventory.js
 * @목적 : 부모메소드(피상속메소드) - 인벤토리를 가지는 객체에 더함
 * @진행 : 개발종료
 * @주의 : 없음
 * @이슈 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

const B_Inventory = (function(superclass){

	class B_Inventory extends superclass {

		constructor(obj) {
		    super(obj);
			this._inventory = {};
		}

		// @DES :: inventory[obj] - 인벤토리
		get inventory() { return JSON.parse(JSON.stringify(this._inventory)); }
		// set inventory() {}

		/**
		 * [ Function :: getInventoryCount ]
		 *
		 * @DES :: 특정 인벤토리 갯수
		 * @IP1 :: res[str]
		 * @O.P ::
		 * @S.E ::
		 */
		getInventoryCount(res) {
			return this.inventory()[res] ? this.inventory()[res] : 0;
		}

		/**
		 * [ Function :: getInventoryWeight ]
		 *
		 * @DES :: 특정 인벤토리 무게
		 * @IP1 :: res[str]
		 * @O.P ::
		 * @S.E ::
		 */
		getInventoryWeight(res) {
			let weight;
			if(this.CODMOS._res[res])
				weight = this.CODMOS._res[res].getWeight() ? this.CODMOS._res[res].getWeight() : 0;
			else
				weight = 0;
			return this.getInventoryCount(res) * weight;
		}

		/**
		 * [ Function :: getEntryInventoryCount ]
		 *
		 * @DES :: 인벤토리 전체 갯수
		 * @O.P :: entryCount[num]
		 */
		getEntryInventoryCount() {
			let entryCount = 0;
			for(let key in this.inventory) {
				entryCount += this.inventory[key];
			}
			return entryCount;
		}

		/**
		 * [ Function :: getEntryInventoryWeight ]
		 *
		 * @DES :: 인벤토리 전체 무게
		 * @O.P :: entryWeight[num]
		 */
		getEntryInventoryWeight() {
			let entryWeight = 0;
			for(let key in this.inventory) {
				let count  = this.inventory[key];
				let weight = this.CODMOS._res[key].weight ? this.CODMOS._res[key].weight : 0;
				entryWeight += count * weight;
			}
			return entryWeight;
		}

		/**
		 * [ Function :: _insertInventory ]
		 *
		 * @DES :: 인벤토리 삽입
		 * @IP1 :: i[obj]
		 */
		_insertInventory(i) {
			if(this._inventory[i._res]) {
				this._inventory[i._res] = ++this._inventory[i._res];
			}
			else {
				this._inventory[i._res] = 1
			}
		}

		/**
		 * [ Function :: _removeInventory ]
		 *
		 * @DES ::
		 * @IP1 ::
		 * @O.P ::
		 * @S.E ::
		 */
		_removeInventory() { /*TODO*/ }

		/**
		 * [ Function :: _clearInventory ]
		 *
		 * @DES ::
		 * @IP1 ::
		 * @O.P ::
		 * @S.E ::
		 */
		_clearInventory() { /*TODO*/ }

	}

	return B_Inventory;
});

export default B_Inventory;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/attr/B_Inventory.js